import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthUser, setAuthUser } from 'src/store/auth';
import { fetchTagsList } from 'src/store/tags';
import { fetchUnreadCount } from 'src/store/chat';

const CHAT_UNREAD_CHECK_INTERVAL = 30 * 1000; // 30 секунд

export default function useFetchStartData() {

	const dispatch = useDispatch();
	const authUser = useSelector((state) => state.auth.authUser);

	const fetchContent = async () => {

		// Загружаем пользователя только если его еще нет
		if (!authUser) {
			await dispatch(getAuthUser());
		}

	};

	useEffect(() => {

		fetchContent();

	}, []);

	useEffect(() => {
		const handleStorageEvent = (e) => {
			if (e.key === 'logout_event') {
				dispatch(setAuthUser(null));
				if (!window.location.hash.startsWith('#/docs/')) {
					window.location.href = '#/login';
				}
			}
		};

		window.addEventListener('storage', handleStorageEvent);
		return () => window.removeEventListener('storage', handleStorageEvent);
	}, []);
	
	// Загружаем теги только ПОСЛЕ успешной авторизации
	useEffect(() => {
		if (authUser) {
			dispatch(fetchTagsList());
		}
	}, [authUser]);

	// Периодически проверяем количество непрочитанных сообщений в чате
	useEffect(() => {
		if (!authUser) return;

		dispatch(fetchUnreadCount());

		const intervalId = setInterval(() => {
			dispatch(fetchUnreadCount());
		}, CHAT_UNREAD_CHECK_INTERVAL);

		return () => clearInterval(intervalId);
	}, [authUser, dispatch]);

};
